// extracted by mini-css-extract-plugin
export var icon = "whiteHalva-module--icon--QxPaK";